import apiClient from '../authentication/utils/core/axios';

/**
 * OrgRolesAPI — the company org chart (CEO, CTO, Marketing Lead, ...) that
 * Company Ops tasks are tagged with, and that real user accounts get mapped
 * onto (many-to-many, supports co-owned roles).
 */
const OrgRolesAPI = {
  fetchRoles: async () => {
    const res = await apiClient.get('/admin/org-roles/', { timeout: 30000 });
    return res.data;
  },

  createRole: async (roleData) => {
    const res = await apiClient.post('/admin/org-roles/', roleData);
    return res.data;
  },

  updateRole: async (roleId, updates) => {
    const res = await apiClient.patch(`/admin/org-roles/${roleId}`, updates);
    return res.data;
  },

  deleteRole: async (roleId) => {
    await apiClient.delete(`/admin/org-roles/${roleId}`);
    return roleId;
  },

  fetchHolders: async (roleId) => {
    const res = await apiClient.get(`/admin/org-roles/${roleId}/users`);
    return { roleId, holders: res.data };
  },

  mapUser: async (roleId, userId) => {
    const res = await apiClient.post(`/admin/org-roles/${roleId}/users`, { user_id: userId });
    return { roleId, holder: res.data };
  },

  unmapUser: async (roleId, userId) => {
    await apiClient.delete(`/admin/org-roles/${roleId}/users/${userId}`);
    return { roleId, userId };
  },
};

export default OrgRolesAPI;
